import api from '../api';

export const addUpdateBusinessLocations = (data) => api.post('/core/functions/addUpdateBusinessLocations', data);

export const removeBusinessLocation = (data) => api.post('/core/functions/removeBusinessLocation', data);

export const fetchBusinessLocations = (data) => api.post('/core/functions/fetchBusinessLocations', data);

export const fetchBusinessLocation = (data) => api.post('/core/functions/fetchBusinessLocation', data);
